<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                this.$l('form_label_search') ||
                '请款单编号/业务人员/供应商/客户/付款方 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="
                openEditPage({
                  pageType: 'add',
                  params: {},
                })
              "
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="140px" size="small">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item
              :label="
                $l('form_label_search_userPaymentRequestStatus') ||
                '订单费用状态'
              "
            >
              <el-checkbox-group v-model="form.userPaymentRequestStatusList">
                <el-checkbox label="N">{{
                  $l('form_label_userPaymentRequestStatus_N') || '新增'
                }}</el-checkbox>
                <el-checkbox label="S">{{
                  $l('form_label_userPaymentRequestStatus_S') || '已提交'
                }}</el-checkbox>
                <el-checkbox label="R">{{
                  $l('form_label_userPaymentRequestStatus_R') || '已驳回'
                }}</el-checkbox>
                <el-checkbox label="Y">{{
                  $l('form_label_userPaymentRequestStatus_Y') || '已审核'
                }}</el-checkbox>
                <el-checkbox label="D">{{
                  $l('form_label_userPaymentRequestStatus_D') || '已删除'
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_userPaymentRequestNo') || '请款单号'"
            >
              <el-input
                v-model.trim="form.userPaymentRequestNo"
                :placeholder="
                  $l('tips_input_userPaymentRequestNo') || '请输入请款单号...'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_salesPersonCode') || '业务人员'"
            >
              <dict-select
                v-model="form.salesPersonCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('tips_select_salesPersonCode') || '请选择业务人员'
                "
                clearable
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_payeeScmCode') || '收款供应商'"
            >
              <dict-select
                v-model="form.payeeScmCode"
                url="/master/common/dict/allScmCooperated"
                :placeholder="
                  $l('tips_select_payeeScmCode') || '请选择收款供应商'
                "
                clearable
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_payeeCust') || '收款客户'">
              <dict-select
                v-model="form.payeeCustCode"
                url="/master/common/dict/customerSelect"
                :placeholder="
                  $l('tips_select_payeeCustCode') || '请选择收款客户'
                "
                clearable
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_expensePayer') || '付款公司'">
              <dict-select
                v-model="form.expensePayerCode"
                :body="expensePayerParams"
                url="/master/common/dict/biz"
                :placeholder="
                  $l('tips_select_expensePayer') || '请选择付款公司'
                "
                filterable
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_paymentMethod') || '付款方式'">
              <dict-select
                v-model="form.paymentMethodList"
                :body="paymentMethodParams"
                url="/master/common/dict/biz"
                :placeholder="
                  $l('tips_select_paymentMethod') || '请选择付款方式'
                "
                filterable
                clearable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_bank_name') || '开户银行'">
              <el-input
                v-model.trim="form.bankName"
                :placeholder="
                  $l('tips_select_payee_bank_name') || '请选择收款方开户银行'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_bank_account_name') || '账户名称'"
            >
              <el-input
                v-model.trim="form.bankAccountName"
                :placeholder="
                  $l('tips_input_bank_account_name') || '请输入账户名称...'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_bank_account_no') || '银行账号'"
            >
              <el-input
                v-model.trim="form.bankAccountNo"
                :placeholder="
                  $l('tips_input_bank_account_no') || '请输入银行账号...'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_bank_account_type') || '账户性质'"
            >
              <el-select
                size="small"
                v-model="form.bankAccountType"
                :placeholder="
                  $l('tips_select_bank_account_type') || '请选择账户性质'
                "
                style="width: 100%"
                filterable
                clearable
              >
                <el-option
                  v-for="item in bankAccountOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_bank_account_kind') || '账号类别'"
              prop="bankAccountKind"
            >
              <dict-select
                size="small"
                clearable
                filterable
                v-model="form.bankAccountKind"
                :placeholder="
                  $l('tips_select_bank_account_kind') || '请选择账号类别...'
                "
                :body="bankAccountKindParams"
                url="/master/common/dict/biz"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item :label="$l('form_label_requestDate') || '申请日期'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginRequestDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="requestDateStartPicker"
                    :placeholder="
                      $l('tips_select_requestDateStart') || '请选择申请日期'
                    "
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endRequestDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="requestDateEndPicker"
                    :placeholder="
                      $l('tips_select_requestDateEnd') || '请选择申请日期'
                    "
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-row>
              <el-form-item :label="$l('form_label_createDate') || '创建时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createTimeStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="createTimeStartPicker"
                    :placeholder="
                      $l('tips_select_createDateStart') || '请选择创建时间'
                    "
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createTimeEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="createTimeEndPicker"
                    :placeholder="
                      $l('tips_select_createDateEnd') || '请选择创建时间'
                    "
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item :label="$l('form_label_modifyDate') || '修改时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginModifyTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="modifyTimeStartPicker"
                    :placeholder="
                      $l('tips_select_modifyDateStart') || '请选择修改时间'
                    "
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endModifyTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="modifyTimeEndPicker"
                    :placeholder="
                      $l('tips_select_modifyDateEnd') || '请选择修改时间'
                    "
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  userPaymentRequestStatusList: ['N', 'S', 'R', 'Y'],
}
export default {
  data() {
    return {
      userPaymentRequestStatusParams: { dictType: 'userPaymentRequestStatus' },
      paymentMethodParams: { dictType: 'paymentMethod' },
      expensePayerParams: { dictType: 'expensePayer' },
      advqueryDialogVisible: false,
      form: { ...initForm },
      bankAccountKindParams: { dictType: 'bankAccountKind' },
      bankAccountOptions: [
        {
          label: this.$l('form_label_company') || '公司',
          value: '0',
        },
        {
          label: this.$l('form_label_personal') || '个人',
          value: '1',
        },
      ],
      //申请日期限制
      requestDateStartPicker: this.requestDateEnd(),
      requestDateEndPicker: this.requestDateStart(),

      //创建日期限制
      createTimeStartPicker: this.createTimeEnd(),
      createTimeEndPicker: this.createTimeStart(),
      //修改日期限制
      modifyTimeStartPicker: this.modifyTimeEnd(),
      modifyTimeEndPicker: this.modifyTimeStart(),
    }
  },

  mounted() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },

    openEditPage({ pageType, params = {} }) {
      this.$router.push({
        name: 'personal-myPaymentRequest-detail',
        params: { ...params, pageType },
      })
    },
    // 创建日期限制
    createTimeEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.createTimeEnd) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.createTimeEnd).getTime() < time.getTime()
          }
        },
      }
    },
    createTimeStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.createTimeStart) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.createTimeStart).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    // 修改时间限制
    modifyTimeEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.endModifyTime) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.endModifyTime).getTime() < time.getTime()
          }
        },
      }
    },
    modifyTimeStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.beginModifyTime) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.beginModifyTime).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    // 提交时间限制
    requestDateEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.endRequestDate) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.endRequestDate).getTime() < time.getTime()
          }
        },
      }
    },
    requestDateStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.beginRequestDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.beginRequestDate).getTime() -
                3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
